import { useState, useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import ActivityNotification from './ActivityNotification';
import { activityUtils } from '../utils/activity';

const Layout = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    
    useEffect(() => {
        // Try to load real notifications from Firebase
        let unsubscribe = () => {};
        
        const loadNotifications = async () => {
            try {
                // First, load static notifications
                const activities = await activityUtils.getRecentActivities(10);
                if (activities.length > 0) {
                    setNotifications(activities);
                }
                
                // Then set up real-time listener
                unsubscribe = activityUtils.listenForActivities((realtimeActivities) => {
                    if (realtimeActivities.length > 0) {
                        setNotifications(realtimeActivities);
                    }
                });
            } catch (error) {
                console.error("Error loading notifications:", error);
            }
        };
        
        // Only attempt to load if we're on the client-side
        if (typeof window !== 'undefined') {
            loadNotifications();
        }
        
        // Clean up listener
        return () => {
            if (unsubscribe) {
                unsubscribe();
            }
        };
    }, []);
    
    return (
        <div className="flex flex-col min-h-screen">
            <Header />
            <main id="main-content" className="flex-grow container mx-auto p-4">
                {children}
            </main>
            <ActivityNotification firebaseNotifications={notifications} />
            <Footer />
        </div>
    );
};

export default Layout;
